import { render, staticRenderFns } from "./OverviewInfoEditor.vue?vue&type=template&id=9c018fa6&"
import script from "./OverviewInfoEditor.vue?vue&type=script&lang=js&"
export * from "./OverviewInfoEditor.vue?vue&type=script&lang=js&"
import style0 from "./OverviewInfoEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports